// draftsTab/state.js

export const draftsTabUIInitialState = {
  showDelForm: false,
  showTransferDelModal: false,
};
